import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/shared/modal/Modal";
import styled from "styled-components/macro";
import LabelledTextInput from "components/shared/LabelledTextInput";
import { Button } from "components/shared/standardElements";
import { useForm } from "react-hook-form";
import { COLORS, FONTSIZE } from "helpers/designConstants";

const EditSectionNameModal = ({
  show,
  onClose,
  currentName,
  onSave,
  isNew
}) => {
  const { t } = useTranslation();
  const {
    register,
    watch,
    handleSubmit,
    resetField,
    formState: { errors }
  } = useForm();

  const { ref: formRef, ...nameRegister } = register("name", { required: true });
  const inputNodeRef = useRef(null);

  const inputRef = (node) => {
    formRef(node);
    inputNodeRef.current = node;
  };

  // Focus and select the input each time the modal opens
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        inputNodeRef.current?.focus();
        inputNodeRef.current?.select();
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const onSubmit = (data) => {
    onSave(data.name);
    resetField("name");
  };

  const closeModal = () => {
    onClose();
    resetField("name");
  };

  const watchName = watch("name");

  return (
    <Modal
      title={isNew ? (t("new_group") || "New Group") : (t("edit_group_name") || "Edit Group Name")}
      show={show}
      onClose={closeModal}
      disableCloseOnOutsideClick
    >
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <LabelledTextInput
          labelText={t("name_title") || "Name"}
          type="text"
          id="name"
          name="name"
          defaultValue={currentName}
          placeholder={t("name_title") || "Name"}
          ref={inputRef}
          {...nameRegister}
        />
        {errors.name && (
          <StyledInputErrorMessage>
            {t("name_required") || "Name is required"}
          </StyledInputErrorMessage>
        )}
        <StyledButton disabled={watchName?.length === 0 || !watchName}>
          {t("save_button") || "Save"}
        </StyledButton>
      </StyledForm>
    </Modal>
  );
};

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
`;

const StyledInputErrorMessage = styled.div`
  padding: 3px 0 0 5px;
  color: ${COLORS.alertRed};
  font-size: ${FONTSIZE.xsmall};
  align-self: flex-start;
`;

const StyledButton = styled(Button)`
  margin-top: 20px;
`;

export default EditSectionNameModal;
